import {useContext, useEffect, useId, useRef, useState} from "react";
import {ApiContext} from "../../../util/Requests";
import SimpleModal from "../SimpleModal";
import "./InteractiveModals.scss";
import {applyLastClickedIndicator} from "../../../util/LinkUtils";


/**
 * @param
 * @param linkPermissions {(v: SC_Permissions) => boolean}
 * @return {JSX.Element}
 * @constructor
 */
const PreviewModal = ({isOpen, setIsOpen, children, linkContent, linkHref, modalTitle, requestedSizing, linkPermissions = () => true}) => {
    const myid = useId();

    const [localOpenness, setLocalOpenness] = useState(false);
    const [everOpen, setEverOpen] = useState(undefined);

    const {modals, caches} = useContext(ApiContext);

    const modal = useRef(null);

    useEffect(() => {
        if (isOpen || localOpenness) {
            modals.add(myid, modal);
        } else {
            modals.remove(myid);
        }
    }, [isOpen, localOpenness]);

    useEffect(() => {
        return () => {
            modals.remove(myid);
        }
    }, []);

    const linkRef = useRef(null);

    useEffect(() => {
        if (everOpen === undefined)
            return;
        if (linkRef.current) {
            applyLastClickedIndicator(linkRef.current, !localOpenness);
        }
    }, [localOpenness]);

    useEffect(() => {
        if (!children) {
            modal.current = null;
            modals.remove(myid);
            return;
        }

        modal.current = <SimpleModal requestedSizing={requestedSizing} isOpen={true} title={modalTitle} onClose={() => {
            setEverOpen(true);
            (setIsOpen ?? setLocalOpenness)(false);
            modals.remove(myid);
        }}>
            {children}
        </SimpleModal>;
    }, [children]);

    if (linkContent) {
        if (linkPermissions(caches.permissions.ref.current)) {
            return <a ref={linkRef} href={linkHref} onClick={(e) => {
                if (e.ctrlKey || e.metaKey || e.shiftKey)
                    return;

                e.preventDefault();
                e.stopPropagation();

                setEverOpen(true);

                (setIsOpen ?? setLocalOpenness)(true);
            }}>{linkContent}</a>
        } else {
            return <span>{linkContent}</span>;
        }
    }

    return <div style={{display: "none"}}/>
}

export default PreviewModal;